export default __webpack_public_path__ + "static/MediaContentTwo-73b314ec2f3790005b48020c0c74ea96.webp";